import dayjs from 'dayjs'
import {TKey} from '@/translations/i18n'
import {
    SiarBulkExportType,
    SiarExport,
    SiarExportStatus,
    SiarExportsColumn
} from '@/features/projects/siar-bulk-export/types'

export const buildSiarExportDisplayName = (
    siarExport: Pick<SiarExport, 'exportType' | 'dateFrom' | 'dateTo'>
): string => {
    const prefix = siarExport.exportType === 'open_project' ? 'SIAR-Apertura' : 'SIAR-Chiusura'
    const fmt = (d: string) => dayjs(d).format('DDMMYYYY')
    const from = siarExport.dateFrom ? fmt(siarExport.dateFrom) : null
    const to = siarExport.dateTo ? fmt(siarExport.dateTo) : null
    if (from && to) return `${prefix}-${from}-${to}.zip`
    if (from) return `${prefix}-${from}.zip`
    if (to) return `${prefix}-${to}.zip`
    return `${prefix}.zip`
}

export const siarExportTypeToLabel = {
    open_project: 'projects:bulk_siar_export_type_open',
    close_project: 'projects:bulk_siar_export_type_close'
} as const satisfies Record<SiarBulkExportType, TKey>

export const siarExportTypeToNoEligibleProjectsLabel = {
    open_project: 'projects:bulk_siar_export_no_eligible_projects_open',
    close_project: 'projects:bulk_siar_export_no_eligible_projects_close'
} as const satisfies Record<SiarBulkExportType, TKey>

export const siarExportStatusToLabel = {
    PENDING: 'projects:bulk_siar_export_status_pending',
    TRANSMITTED: 'projects:bulk_siar_export_status_transmitted',
    CANCELLED: 'projects:bulk_siar_export_status_cancelled'
} as const satisfies Record<SiarExportStatus, TKey>

export const siarExportStatusToBadgeVariant = {
    PENDING: 'orange',
    TRANSMITTED: 'success',
    CANCELLED: 'neutral'
} as const satisfies Record<SiarExportStatus, 'orange' | 'success' | 'neutral'>

export const siarExportColumnToLabel = {
    exportType: 'projects:bulk_siar_export_column_type',
    period: 'projects:bulk_siar_export_column_period',
    createdAtAndAuthor: 'projects:bulk_siar_export_column_created_at',
    status: 'projects:bulk_siar_export_column_status',
    transmittedAt: 'projects:bulk_siar_export_column_transmitted_at',
    name: 'projects:bulk_siar_export_column_name',
    moreActions: 'commons:actions'
} as const satisfies Record<SiarExportsColumn, TKey>
